import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Button } from "@mui/material";
import { TiTick } from "react-icons/ti";
import SearchableDropdown from "../../../Component/DigitalMarketing/Forms/SearchableDropdown";
import { Col, Row } from "react-bootstrap";
import {
  useAddAppointmentMutation,
  useGetFilterCustomerListQuery,
  useUpdateAppointmentMutation,
} from "../../../Service/appoinment";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isValidDate } from "../../../utils";
import { SetAppointmentLabel } from "./Utils";
import {
  useAddCustomerBloodAppointmentMutation,
  useUpdateCustomerBloodAppointmentMutation,
} from "../../../Service/CustomerBloodAppointment";

function CustomerBloodAppointment(props) {
  const { id, callBackforErrorMessage, openSnackBar, details } = props;
  console.log(details);

  const [name, setname] = useState("");

  const [appointment, setAppointment] = useState<any>({});
  const navigate = useNavigate();
  const [addAppointment, { isLoading: addLoading }] =
    useAddCustomerBloodAppointmentMutation();

  const [updateAppointment, { isLoading: updateLoading }] =
    useUpdateCustomerBloodAppointmentMutation();

  // const response = useGetFilterCustomerListQuery(name);
  const {
    data,
    refetch: refetchname,
    isLoading,
  } = useGetFilterCustomerListQuery(name, {
    refetchOnMountOrArgChange: true,
  });

  let customer = data?.[0] || [];
  const Option = Array.isArray(customer)
    ? customer
        .map((item: any) => {
          if (item.phone_number) {
            return {
              value: item.customerId,
              label: `${item.customerName} ${item.phone_number}`,
              label1: item.customerName,
            };
          }
          return null;
        })
        .filter((item) => item !== null)
    : [];
  const path = window.location.pathname;

  const OnHandleChange = (event) => {
    const { name, value } = event.target;
    console.log(appointment);

    setAppointment((prevState) => ({ ...prevState, [name]: value }));
  };

  const onSubmit = async () => {
    let data: any = {
      ...appointment,
    };

    if (
      data.customerId &&
      isValidDate(data.bloodTestDate) &&
      data.bloodTestTime
    ) {
      if (path.split("/")[2] === "reschedule") {
        try {
          const payload = await updateAppointment({
            id: id,
            ...data,
          }).unwrap();
          openSnackBar("Updated successfully");
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        } catch (error: any) {
          openSnackBar(error.data.error, "error");
        }
      } else {
        try {
          const payload = await addAppointment(data).unwrap();
          openSnackBar("Added successfully");
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        } catch (error: any) {
          openSnackBar(error.data.error, "error");
        }
      }
    } else {
      if (!data.customerId) {
        openSnackBar("Please select customer", "error");
      } else if (!isValidDate(data.bloodTestDate)) {
        openSnackBar("Incorrect date format", "error");
      } else if (!data.bloodTestTime) {
        openSnackBar("Please select time", "error");
      } else {
        openSnackBar("Please fill all data before submit!", "error");
      }
    }
  };

  useEffect(() => {
    details && setAppointment({ ...details, reason: "" });
  }, [details]);
  useEffect(() => {
    refetchname();
  }, [name]);

  return (
    <>
      {path.split("/")[2] === "reschedule" ? (
        details?.customerId && (
          <>
            <li>
              <div className="mb-2">
                <span className="title">Appointment</span>
                <Button
                  onClick={() => onSubmit()}
                  id="btn-blue-2"
                  disabled={updateLoading}
                >
                  <TiTick style={{ marginTop: "-2px" }} />
                  &nbsp;
                  {updateLoading ? "Wait" : "Reschedule"}
                </Button>
              </div>
            </li>
            <li>
              <Row>
                <Col className="mt-2" md={8}>
                  <SearchableDropdown
                    setname={setname}
                    Option={Option}
                    handleChange={OnHandleChange}
                    {...appointment}
                    labelClass="f-14"
                    disab={true}
                    key_name="customerId"
                    label="Customer Name"
                  />
                </Col>
                <Col className="mt-2" md={12}>
                  <span className="sub-title">Set an appointment</span>
                  <Row>
                    {SetAppointmentLabel.map((item, index) => {
                      return (
                        <Col xs={12} md={6} className="mt-2" key={index}>
                          <item.tag
                            {...item}
                            labelStyle="f-14"
                            handleChange={OnHandleChange}
                            previousAppointmentDate={details?.bloodTestDate}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </li>
          </>
        )
      ) : (
        <>
          <li>
            <div className="mb-2">
              <span className="title">Blood test appointment</span>
              <Button
                onClick={() => onSubmit()}
                variant="contained"
                id="btn-blue"
                disabled={addLoading}
              >
                <TiTick style={{ marginTop: "-2px" }} />
                &nbsp;{addLoading ? "Wait" : "Schedule"}
              </Button>
            </div>
          </li>
          <li>
            <Row>
              <Col className="mt-2" md={8}>
                <SearchableDropdown
                  setname={setname}
                  Option={Option}
                  labelClass="f-14"
                  key_name="customerId"
                  handleChange={OnHandleChange}
                  label="Customer Name"
                />
              </Col>

              <Col className="mt-2" md={12}>
                <span className="sub-title">Set an appointment</span>
                <Row>
                  {SetAppointmentLabel.map((item, index) => {
                    return (
                      <Col md={6} key={index}>
                        <item.tag
                          {...item}
                          labelStyle="f-14"
                          handleChange={OnHandleChange}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </li>
        </>
      )}
    </>
  );
}

export default React.memo(CustomerBloodAppointment);
